import {
  FormControl,
  OutlinedInput,
  OutlinedInputProps,
  TextFieldProps,
  FormHelperText,
} from "@material-ui/core";
import React from "react";

import {
  useStyles,
  useHelperTextStyles,
  useBaseStyles,
} from "./InputField.style";

export function InputField(props: OutlinedInputProps | TextFieldProps) {
  const classes = useStyles(props);
  const baseClasses = useBaseStyles(props);
  const textHelperClasses = useHelperTextStyles(props);

  return (
    <FormControl variant="outlined" hiddenLabel fullWidth={props.fullWidth}>
      {props.label !== null ? (
        <label htmlFor={props.id} className={baseClasses.label}>
          {props.label}
        </label>
      ) : (
        <></>
      )}
      <OutlinedInput
        notched={false}
        autoComplete="off"
        classes={classes}
        inputRef={props.inputRef}
        {...(props as OutlinedInputProps)}
      />
      {(props as TextFieldProps).helperText ? (
        <FormHelperText className={textHelperClasses.root}>
          {(props as TextFieldProps).helperText}
        </FormHelperText>
      ) : (
        <></>
      )}
    </FormControl>
  );
}
